import { getAppEnvironment } from '../../../../../../../../helper'

export const backgroundTypes = (t) => [
	{ value: 'light', src: '/img/constructorImg/light.webp', label: t('product.form.menuV2.image.viewLight') },
	{ value: 'dark', src: '/img/constructorImg/dark.webp', label: t('product.form.menuV2.image.viewDark') },
	{ value: 'red', src: '/img/constructorImg/red.webp', label: t('product.form.menuV2.image.viewRed') },
]

const MENU_SLUGS = [
	'casserole-beer',
	'casserole-drink',
	'baguette-beer',
	'baguette-drink',
	'burger-fries',
	'burger-fries-drink',
	'fish-beer',
	'meat-drink',
	'grill-beer',
	'grill-drink',
	'noodles-beer',
	'noodles-drink',
	'pasta-beer',
	'pasta-drink',
	'pizza-beer',
	'pizza-drink',
	'salad-beer',
	'schnitzel-beer',
	'schnitzel-drink',
	'asparagus-broccoli-pizza',
	'asparagus-pizza',
	'asparagus-schnitzel',
]

const getCloudinaryMenuImgPath = (theme) => `https://res.cloudinary.com/liefersoft-${getAppEnvironment()}/image/upload/menus/${theme}`

export const getMenuOptions = (theme) => {
	const menuImgPath = getCloudinaryMenuImgPath(theme)
	return MENU_SLUGS.map(slug => ({
		value: slug,
		label: `product.form.menuV2.image.menus.${slug}`,
		url: `${menuImgPath}/${slug}.webp`,
	}))
}

export const sortMenuOptions = (a, b) => {
	return a.label.localeCompare(b.label)
}
